import Navbar from "../../shared/navbar";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "./new-password.css";
import axios from "axios";
import { ALERT, BASE_URL } from "../../config/constants";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export default function NewPassword() {
  const navigate = useNavigate();

  const schemaPassword = yup.object().shape({
    newPassword: yup
      .string()
      .max(25, "Excede el número de caracteres")
      .required("La contraseña es obligatoria")
      .matches(
        /[!@#$%^&*()_+\-={};':"|,.<>?]/,
        "La contraseña debe contener al menos un caracter especial",
      )
      .matches(/[A-Z]/, "La contraseña debe tener al menos una letra mayúscula")
      .notOneOf([
        "titan",
        "Titan",
        "Titan1234567",
        "Titan123456*",
        "Decoblock",
        "1234",
        "deco",
        "Decoblock",
        "Deco",
      ])
      .test(
        "password",
        "La contraseña debe tener al menos 12 caracteres, contener al menos un número, un caracter especial y no contener su nombre o palabras clave",
        (value) => {
          return (
            value && value.length >= 12 && /[0-9]/.test(value) // Verificar que la contraseña contenga al menos un número
          );
        },
      ),
    password2: yup
      .string()
      .required("Conrimación requerida")
      .test("password", "Los caracteres no coinciden", function (value) {
        return value === this.parent.newPassword;
      }),
  });

  //<<<...Petición para la nueva contraseña...>>>
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onblur",
    resolver: yupResolver(schemaPassword),
  });

  async function newPassword(data) {
    const url = window.location.search;
    const params = new URLSearchParams(url.split("?")[1]);
    const token = params.get("token");
    await axios
      .put(BASE_URL + "/auth/login/new-password", data, {
        headers: {
          Authorization: `${token}`,
        },
      })
      .then((res) => {
        ALERT.fire({
          icon: "success",
          title: "¡...Cambio de contraseña exitosa...!",
        });
        navigate("/login");
      })
      .catch((err) => {
        ALERT.fire({
          icon: "error",
          title:
            "¡...Algó pasó, intenta de nuevo ó exediste el tiempo pemitido...!",
        });
      });
  }

  return (
    <div className="new-password">
      <div className="tittle">
        <div className="cabecera">
          <div className="navbarRegister">
            <Navbar />
          </div>
        </div>
      </div>

      <div className="box-newpassword">
        <form onSubmit={handleSubmit(newPassword)}>
          <section id="subsection-password">
            {/*Subsection title*/}
            <h4 className="mt-5">Advertencia</h4>
            {/*Description*/}
            <p>
              Recuerda que la contraseña debe tener mínimo una mayúscula, un
              caracter especial, no debe contener tu nombre o el de la compañía
              y al menos 12 caracteres.
            </p>
            {/*Section: Demo*/}
            <section className="pb-4">
              <div className="bg-white border rounded-5">
                <section className="w-100 p-4 d-flex justify-content-center pb-4">
                  <div className="form-outline" style={{ width: "22rem" }}>
                    <label
                      className="form-label"
                      htmlFor="typePassword"
                      style={{ marginLeft: 0 }}
                    >
                      Contraseña nueva
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      {...register("newPassword")}
                    />
                    <div className="error">
                      {!!errors?.newPassword}
                      {errors?.newPassword?.message}
                    </div>
                    <br />
                    <label
                      className="form-label"
                      htmlFor="typePassword"
                      style={{ marginLeft: 0 }}
                    >
                      Confimar contraseña
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      {...register("password2")}
                    />
                    <div className="error">
                      {!!errors.password2}
                      {errors?.password2?.message}
                    </div>
                    <div className="form-notch">
                      <div
                        className="form-notch-leading"
                        style={{ width: 9 }}
                      />
                      <div
                        className="form-notch-middle"
                        style={{ width: 96 }}
                      />
                      <div className="form-notch-trailing" />
                    </div>
                  </div>
                </section>
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  Iniciar sesión
                </button>
              </div>
            </section>
          </section>
        </form>
      </div>
    </div>
  );
}
